import React from 'react';

interface SectionHeadingProps {
  title: string;
  /** Optional line under the title explaining the section. */
  description?: React.ReactNode;
}

/** Title of a section within an onboarding stage, e.g. "Phone Number Preferences". */
export const SectionHeading: React.FC<SectionHeadingProps> = ({ title, description }) => (
  <div className="border-b pb-2">
    <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{title}</h3>
    {description && <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">{description}</p>}
  </div>
);
